import { PackageAssetTypeAttributes } from '@/types'
import { CreatePackageAssetTypeMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  defaultValues: Partial<PackageAssetTypeAttributes>
  onSuccess: () => void
}

export const Form = ({ defaultValues, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
  } = useForm<CreatePackageAssetTypeMutation, PackageAssetTypeAttributes, never, never>({
    defaultValues: {
      packageId: '',
      assetTypeId: '',
      quantity: 1,
      ...defaultValues
    },
    mutation: CreateMutation,
    resultKey: 'createPackageAssetType',
    refetchQueries: [TableQuery]

  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      <div className="grid grid-cols-2 gap-6">
        { formBuilder.buildField({ name: 'Asset type', field: 'assetTypeId', type: 'asset-type' }) }
        { formBuilder.buildField({ name: 'Quantity', field: 'quantity', type: 'integer' }) }
      </div>
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
